<div class="notification-icon" *ngIf="hasItems">
    <mat-icon [class.has-items]="hasItems" (click)="toggleMessage()">notifications</mat-icon>
    <div class="message"
         [class.opened]="isMessageOpened"
         #notificationMessage
         *ngIf="hasItems"
         tabindex="1"
         (blur)="hideMessage()">
        <ng-content select="[message]"></ng-content>
    </div>
</div>
